module.exports = __webpack_public_path__ + "static/media/summaryMaker.03dc32fe.svg";